import { IBoxScoreBatter } from 'interfaces/boxScore/IBoxScoreBatter';
import { IBoxScorePitcher } from 'interfaces/boxScore/IBoxScorePitcher';

export const pitcherToCombinedBoxScoreData = (player: IBoxScorePitcher, secondSourcePlayers: IBoxScorePitcher[]) => {
  const secondSourcePlayer = secondSourcePlayers.find((secondPlayer) => player.playerId === secondPlayer.playerId);

  return {
    ...player,
    ip: {
      sourceValue: player.ip,
      secondValue: secondSourcePlayer?.ip,
    },
    h: {
      sourceValue: player.h,
      secondValue: secondSourcePlayer?.h,
    },
    so: {
      sourceValue: player.so,
      secondValue: secondSourcePlayer?.so,
    },
    bb: {
      sourceValue: player.bb,
      secondValue: secondSourcePlayer?.bb,
    },
    bf: {
      sourceValue: player.bf,
      secondValue: secondSourcePlayer?.bf,
    },
  };
};

export const batterToCombinedBoxScoreData = (player: IBoxScoreBatter, secondSourcePlayers: IBoxScoreBatter[]) => {
  const secondSourcePlayer = secondSourcePlayers.find((secondPlayer) => player.playerId === secondPlayer.playerId);

  return {
    ...player,
    ip: {
      sourceValue: player.ip,
      secondValue: secondSourcePlayer?.ip,
    },
    ab: {
      sourceValue: player.ab,
      secondValue: secondSourcePlayer?.ab,
    },
    h: {
      sourceValue: player.h,
      secondValue: secondSourcePlayer?.h,
    },
    bb: {
      sourceValue: player.bb,
      secondValue: secondSourcePlayer?.bb,
    },
    hbp: {
      sourceValue: player.hbp,
      secondValue: secondSourcePlayer?.hbp,
    },
    sac: {
      sourceValue: player.sac,
      secondValue: secondSourcePlayer?.sac,
    },
    rbi: {
      sourceValue: player.rbi,
      secondValue: secondSourcePlayer?.rbi,
    },
    '2B': {
      sourceValue: player['2B'],
      secondValue: secondSourcePlayer ? secondSourcePlayer['2B'] : undefined,
    },
    '3B': {
      sourceValue: player['3B'],
      secondValue: secondSourcePlayer ? secondSourcePlayer['3B'] : undefined,
    },
    hr: {
      sourceValue: player.hr,
      secondValue: secondSourcePlayer?.hr,
    },
    k: {
      sourceValue: player.k,
      secondValue: secondSourcePlayer?.k,
    },
  };
};
